import { Row, Col, DatePicker } from "antd";
import CardHeader from "../../../components/atoms/cardHeader";
import { ContentInputField } from "../../../components/atoms/formFields/inputField/contentInputField";
import { AllRangePicker } from "../../../components/atoms/formFields/rangePicker/allRangePicker";
import dayjs from "dayjs";
import { CommomSelect } from "../../../components/atoms/formFields/CommonSelect";
import AllDatePicker from "../../../components/atoms/formFields/datePicker/allDatePicker";
import { useState } from "react";

export const OrderFilter = ({ setSubmit, submit, setOffset ,setTabKey}) => {
  console.log("setTabKey iner",setTabKey)
  const paymentOptions = [
    { value: "INSTAMOJO", label: "PREPAID" },
    { value: "CASH_ON_DELIVERY", label: "COD" },
  ];
  const paymentStatus = [
    { value: "DONE", label: "PAID" },
    { value: "PENDING", label: "UNPAID" },
  ];

  const OrderStatus = [
    { label: "PACKED", value: "PACKED" },
    { label: "CANCELLED", value: "CANCELLED" },
    { label: "DELIVERED", value: "DELIVERED" },
    // { label: "ORDER_COMPLETED", value: "ORDER_COMPLETED" },
    { label: "PROCESSING", value: "PROCESSING" },
    { label: "RTO_INITIATED", value: "RTO_INITIATED" },
    { label: "RTO_DELIVERED", value: "RTO_DELIVERED" },
  ];

  const DeliveryOptions = [
    { value: "PICK_UP_FROM_VENDOR", label: "In-Store Pickup" },
    { value: "HOME_DELIVERY", label: "Home Delivery" },
  ];

  return (
    <div className="filter_area collapse" id="filter">
      <div className="container">
        <CardHeader name={"Order Filter"} />
        <div className="bg-white mb-10 px-5 py-8 radius-bottom" id="ant_inputs">
          <Row gutter={[12, 12]}>
            <Col className="gutter-row" xs={24} lg={6}>
              <ContentInputField
                name={"Item/Order Id"}
                onChange={(e) => {
                  setSubmit({
                    ...submit,
                    paginationFilter: {
                      ...submit.paginationFilter,
                      limit: 10,
                      offset: 0,
                      order: "DESC",
                    },
                    orderId: e.target.value,
                  });
                  setOffset(0);
                }}
                value={submit?.orderId}
                placeholder="Order Id"
              />
            </Col>
            <Col className="gutter-row" xs={24} lg={6}>
              <ContentInputField
                name={"Customer Name"}
                onChange={(e) => {
                  setSubmit({
                    ...submit,
                    paginationFilter: {
                      ...submit.paginationFilter,
                      limit: 10,
                      offset: 0,
                      order: "DESC",
                    },
                    customerName: e.target.value,
                  });
                  setOffset(0);
                }}
                value={submit?.customerName}
                placeholder="Customer Name"
              />
            </Col>
            <Col className="gutter-row" xs={24} lg={6}>
              <ContentInputField
                name={"Customer ID"}
                onChange={(e) => {
                  setSubmit({
                    ...submit,
                    paginationFilter: {
                      ...submit.paginationFilter,
                      limit: 10,
                      offset: 0,
                      order: "DESC",
                    },
                    customerId: e.target.value,
                  });
                  setOffset(0);
                }}
                value={submit?.customerId}
                placeholder="Customer ID"
              />
            </Col>
            <Col className="gutter-row" xs={24} lg={6}>
              <ContentInputField
                name={"Product Name"}
                onChange={(e) => {
                  setSubmit({
                    ...submit,
                    paginationFilter: {
                      ...submit.paginationFilter,
                      limit: 10,
                      offset: 0,
                      order: "DESC",
                    },
                    productName: e.target.value,
                  });
                  setOffset(0);
                }}
                value={submit?.productName}
                placeholder="Product Name"
              />
            </Col>
            <Col className="gutter-row" xs={24} lg={6}>
              <CommomSelect
                name={"Payment Mode"}
                value={
                  paymentOptions.find(
                    (option) => option.value === submit?.paymentMethod,
                  ) || null
                }
                options={paymentOptions}
                onChange={(val) => {
                  setSubmit({
                    ...submit,
                    paginationFilter: {
                      ...submit.paginationFilter,
                      limit: 10,
                      offset: 0,
                      order: "DESC",
                    },
                    paymentMethod: val?.value ? val?.value : null,
                  });
                  setOffset(0);
                }}
              />
            </Col>

            <Col className="gutter-row" xs={24} lg={6}>
              <CommomSelect
                name={"Order Status"}
                options={OrderStatus}
                showSearch={true}
                value={
                  submit?.orderStage
                    ? {
                        label: submit?.orderStage,
                        value: submit?.orderStage,
                      }
                    : ""
                }
                onChange={(val) => {
                  if (val) {
                    setSubmit({
                      ...submit,
                      paginationFilter: {
                        ...submit.paginationFilter,
                        limit: 10,
                        offset: 0,
                        order: "DESC",
                      },
                      orderStage: val.value,
                    });
                    setOffset(0);
                  } else {
                    setSubmit({
                      ...submit,
                      paginationFilter: {
                        ...submit.paginationFilter,
                        limit: 10,
                        offset: 0,
                        order: "DESC",
                      },
                      orderStage: null,
                    });
                    setOffset(0);
                  }
                }}
              />
            </Col>
            <Col className="gutter-row" xs={24} lg={6}>
              <CommomSelect
                name={"Settlement Status"}
                value={
                  paymentStatus.find(
                    (option) => option.value === submit?.settlementStatus,
                  ) || null
                }
                options={paymentStatus}
                onChange={(val) => {
                  setSubmit({
                    ...submit,
                    paginationFilter: {
                      ...submit.paginationFilter,
                      limit: 10,
                      offset: 0,
                      order: "DESC",
                    },
                    settlementStatus: val?.value ? val?.value : null,
                  });
                  setOffset(0);
                }}
              />
            </Col>

            <Col className="gutter-row" xs={24} lg={6}>
              {" "}
              <CommomSelect
                name={"Delivery Method"}
                options={DeliveryOptions}
                value={
                  submit?.deliveryWay
                    ? {
                        label:
                          submit?.deliveryWay === "PICK_UP_FROM_VENDOR"
                            ? "In-Store Pickup"
                            : "Home Delivery",
                        value: submit?.deliveryWay,
                      }
                    : ""
                }
                onChange={(val) => {
                  setSubmit({
                    ...submit,
                    paginationFilter: {
                      ...submit.paginationFilter,
                      limit: 10,
                      offset: 0,
                      order: "DESC",
                    },
                    deliveryWay: val?.value ? val?.value : null,
                  });
                  setOffset(0);
                }}
              />
            </Col>

            {/* <Col className="gutter-row" xs={24} lg={6}>
              <ContentInputField
                name={"Phone Number"}
                onChange={(e) => {
                  setSubmit({
                    ...submit,
                    phoneNumber: e.target.value,
                  });
                  setOffset(0);
                }}
                value={submit?.phoneNumber}
                placeholder="Phone Number"
              />
            </Col> */}
            <Col className="gutter-row" xs={24} lg={6}>
              <AllRangePicker
                disabledDate={(current) => {
                  return dayjs().add(0, "days") <= current;
                }}
                name={"Order Date"}
                format={"DD/MM/YYYY"}
                value={[
                  submit?.fromDate && dayjs(submit?.fromDate, "DD/MM/YYYY"),
                  submit?.toDate && dayjs(submit?.toDate, "DD/MM/YYYY"),
                ]}
                onChange={(value, dateString) => {
                  if (value) {
                    setSubmit({
                      ...submit,
                      paginationFilter: {
                        ...submit.paginationFilter,
                        limit: 10,
                        offset: 0,
                        order: "DESC",
                      },
                      fromDate: dayjs(value[0]).format("DD/MM/YYYY"),
                      toDate: dayjs(value[1]).format("DD/MM/YYYY"),
                    });
                    setOffset(0);
                  } else {
                    setSubmit({
                      ...submit,
                      fromDate: "",
                      toDate: "",
                    });
                    setOffset(0);
                  }
                }}
              />
            </Col>

            <Col className="gutter-row" xs={24} lg={6}>
            {/* <AllRangePicker
                disabledDate={(current) => {
                  return dayjs().add(0, "days") <= current;
                }}
                name={"Shipment Date"}
                format={"DD/MM/YYYY"}
                value={[
                  submit?.shipmentDate?.from
                    ? dayjs(submit?.shipmentDate?.from, "DD/MM/YYYY")
                    : null,
                  submit?.shipmentDate?.to
                    ? dayjs(submit?.shipmentDate?.to, "DD/MM/YYYY")
                    : null,
                ]}
                onChange={(value, dateString) => {
  if (value) {
    setSubmit({
      ...submit,
      paginationFilter: {
        ...submit.paginationFilter,
        limit: 10,
        offset: 0,
        order: "DESC",
      },
      orderStage: "PACKED",
      shipmentDate: {
        from: dayjs(value[0]).format("DD/MM/YYYY"),
        to: dayjs(value[1]).format("DD/MM/YYYY"),
      },
    });
    setTabKey("packed");
    setOffset(0);
  } else {
    setSubmit({
      ...submit,
      shipmentDate: {
        from: "",
        to: "",
      },
    });

    setOffset(0);
  }
}}
              /> */}



            
              <AllRangePicker
                disabledDate={(current) => {
                  return dayjs().add(0, "days") <= current;
                }}
                name={"Shipment Date"}
                format={"DD/MM/YYYY"}
                value={[
                  submit?.shipmentDate?.from
                    ? dayjs(submit?.shipmentDate?.from, "DD/MM/YYYY")
                    : null,
                  submit?.shipmentDate?.to
                    ? dayjs(submit?.shipmentDate?.to, "DD/MM/YYYY")
                    : null,
                ]}
                onChange={(value, dateString) => {
                  if (value) {
                    setSubmit({
                      ...submit,
                      paginationFilter: {
                        ...submit.paginationFilter,
                        limit: 10,
                        offset: 0,
                        order: "DESC",
                      },
                      shipmentDate: {
                        from: dayjs(value[0]).format("DD/MM/YYYY"),
                        to: dayjs(value[1]).format("DD/MM/YYYY"),
                      },
                    });
                    setOffset(0);
                  } else {
                    setSubmit({
                      ...submit,
                      shipmentDate: {
                        from: "",
                        to: "",
                      },
                    });
                    setOffset(0);
                  }
                }}
              /> 
            </Col>

            {/* <Col className="gutter-row" xs={24} lg={6}>
              <label className="font-weight-bolder font-size-lg d-block">
                Select Year
              </label>

              <DatePicker
                picker="year"
                className="w-100 rounded-sm"
                minDate={dayjs("2023", "YYYY")}
                maxDate={dayjs()}
                value={submit?.year ? dayjs(submit?.year, "YYYY") : null}
                onChange={(value, dateString) => {
                  if (value) {
                    setSubmit({
                      ...submit,
                      paginationFilter: {
                        ...submit.paginationFilter,
                        limit: 10,
                        offset: 0,
                        order: "DESC",
                      },
                      year: value?.format("YYYY"),
                    });
                    setOffset(0);
                  } else {
                    setSubmit({
                      ...submit,
                      paginationFilter: {
                        ...submit.paginationFilter,
                        limit: 10,
                        offset: 0,
                        order: "DESC",
                      },
                      year: null,
                    });
                    setOffset(0);
                  }
                }}
              />
            </Col> */}
          </Row>
          <div className="mt-2 text-lg-right text-center">
            <button
              type="submit"
              className="all_bottom_buttons"
              onClick={() => {
                // setTabKey("all");
                setSubmit({
                  ...submit,
                  paginationFilter: {
                    limit: 10,
                    offset: 0,
                    order: "DESC",
                  },
                  orderId: "",
                  orderStage: null,
                  settlementStatus: null,
                  customerName: "",
                  customerId: "",
                  productName: "",
                  paymentMethod: null,
                  phoneNumber: "",
                  fromDate: null,
                  toDate: null,
                  deliveryWay: null,
                  isPreBookAble: null,
                  rtoOrder: null,
                  shipmentDate: null,
                  //year: dayjs().format("YYYY"),
                });
              }}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
